module.exports = __webpack_public_path__ + "img/kid6.b1883b61.png";